import { Select, Text } from "@radix-ui/themes";
import {
  Controller,
  FieldPath,
  FieldValues,
  UseFormReturn,
} from "react-hook-form";

export function HookFormSelect<T extends FieldValues>({
  options,
  label,
  name,
  formMethods,
  ...props
}: Select.TriggerProps & {
  label?: string;
  options: { label: string; value: string }[];
  name: FieldPath<T>;
  formMethods?: UseFormReturn<T>;
}) {
  return (
    <Controller
      control={formMethods?.control}
      name={name}
      render={({ field, fieldState }) => (
        <>
          <Text as="label">
            <Text size="1" as="p" className="mb-0.5">
              {label}
            </Text>
            <Select.Root
              size="1"
              value={field.value}
              onValueChange={(value) => field.onChange({ target: { value } })}
            >
              <Select.Trigger
                ref={field.ref}
                disabled={field.disabled}
                className="w-full"
                placeholder="Select an event"
                {...props}
              ></Select.Trigger>
              <Select.Content>
                {options.map(({ label, value }) => (
                  <Select.Item key={value} value={value}>
                    {label}
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Root>
            {fieldState.error && (
              <Text size="1" color="red" as="p" className="mt-0.5">
                {fieldState.error.message}
              </Text>
            )}
          </Text>
        </>
      )}
    />
  );
}
